import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapPanelComponent } from './map-panel.component';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [MapPanelComponent],
  exports: [MapPanelComponent],
  imports: [
    CommonModule,
    GoogleMapsModule
  ],
})
export class MapPanelModule { }
